import { EVENT_HANDLE_GLOBAL_ERROR } from './event-bus/event-types';

const { eventBus } = window.specialtyApp;
export function globalErrorHandler(error) {
    console.log('globalErrorHandler', error);

    const errorModal = $('#errorModal');
    $('[data-error-text]').html(error.message || 'Системная ошибка, попробуйте попытку позднее');
    errorModal.modal('show');

    // Непонятна причина, но при отправке по шине и отлове во вью-компоненте в некоторых случаях логика не срабатывает
    if (false) eventBus.$emit(EVENT_HANDLE_GLOBAL_ERROR, error);
}
